module.exports = __webpack_public_path__ + "static/img/ESG-m_2025.6431fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/ESG-m_2025.jpg
// module id = i97E
// module chunks = 99